import React from "react";

const DirectorCard = ({
  director,
  index,
  hoveredIndex,
  setHoveredIndex,
  imageRef,
}) => {
  return (
    <div
      className="group relative bg-[#010d50] p-4 rounded-3xl shadow-lg m-2 md:m-4 w-full md:w-auto"
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(null)}
    >
      <img
        ref={imageRef}
        src={director.image}
        alt={director.name}
        className="w-full md:w-80 h-auto object-cover mx-auto"
      />
      <div>
        <h3 className="text-md text-white pt-2">{director.name}</h3>
        <p className="text-gray-300 text-sm">{director.title}</p>
      </div>

      {/* Tooltip for large desktop screens - with responsive width */}
      <div
        className={`hidden lg:block absolute z-50 bg-[#010d50] backdrop-blur-lg rounded-3xl p-8 transition-opacity duration-300
          ${hoveredIndex === index || (hoveredIndex === null && index === 0) ? "opacity-100" : "opacity-0 pointer-events-none"}
          ${index % 2 === 0 ? "left-full ml-4 top-0" : "right-full mr-4 top-0"}`}
        style={{
          height: "100%",
          zIndex: 100,
          width: "calc(min(600px, 60vw))",
          maxWidth: "calc(100vw - 100px)",
        }}
      >
        <div className="w-full">
          <h4 className="text-2xl lg:text-4xl text-white font-semibold mb-2">
            {director.name}
          </h4>
          <p className="text-base lg:text-lg text-white/80 pt-2 lg:pt-4">
            {director.description}
          </p>
        </div>
      </div>

      {/* Modal for mobile and tablet - shows on click/hover */}
      <div
        className={`lg:hidden fixed inset-0 z-50 bg-[#010d50]/95 p-6 overflow-auto transition-opacity duration-300
          ${hoveredIndex === index ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      >
        <div className="w-full max-w-2xl mx-auto pt-10">
          <button
            className="absolute top-4 right-4 text-white text-2xl"
            onClick={() => setHoveredIndex(null)}
          >
            ×
          </button>
          <h4 className="text-2xl md:text-3xl text-white font-semibold mb-4">
            {director.name}
          </h4>
          <p className="text-sm md:text-base text-white/80 pb-10">
            {director.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DirectorCard;